export const environment = {
  production: true,
  refCompanyId: 37,
  appName: 'KG Diamonds',
  algoliaAppId: 'SGTTZIO938',
  algoliaSearchOnlyKey: 'c428d99b1b938d5bb665765a24887456',
  dealerClubMode: false,
  hosts: [
    {
      host: 'dev.kg-elastic.mobioffice.io',
      auth: 'trybe-price-dev:Try8ED3VsetA9',
      protocol: 'https',
      port: 443,
    },
  ],
  RESULTS_PER_PAGE: 10,
  INDEX: 'kglattice',
  companyDetails: {
    name: 'KG Diamonds',
    contactNumber: '919925037646',
    contactName: 'Myank Jain',
    webHookInOutUrl: null,
    handleCompanyWebHook: 'https://benara-prod.atishae.com/api/',
    companyLogo:
      'https://img.mobioffice.io/api/containers/37/download/75012e3e-973f-49cb-b2f5-e21ce6f990d0.png',
    priorityBase: 0,
    latitude: null,
    longitude: null,
    distance: null,
    subdomain: 'kgtest',
    productType: 'diamond',
    config: {
      defaultSeo: {
        title: 'KG Diamond | Store powered by MobiOffice',
        favicon:
          'https://res.cloudinary.com/kgdiamonds/image/upload/v1625656015/logo/37_footer.png',
        googleAnalyticsID: 'G-DMLW1FFLHQ',
        description: 'KG Diamond',
        keywords: 'KG Diamond, diamond',
        author: 'KG Diamond',
        'og:title': 'KG Diamond',
        'og:description': 'KG Diamond',
        'og:type': 'website',
        'og:width': 400,
        'og:height': 300,
        'og:image:alt': 'KG Diamond',
        'og:site_name': 'KG Diamond',
        'og:url': 'https://kgdiamonds.dealerclub.in/',
        'og:image':
          'https://res.cloudinary.com/kgdiamonds/image/upload/v1625656015/logo/37_footer.png',
        'og:locale': 'en_IN',
      },
      cludinaryCloud: 'kgdiamonds',
      // s3bucket: {
      //   accessKeyId: 'AKIASQAR4AJ6SQNQ3MXA',
      //   secretAccessKey: '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',
      //   region: 'ap-south-1',
      // },
      s3bucket: {
        accessKeyId: 'AKIASQAR4AJ6SXP2AAHW',
        secretAccessKey: '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',
        region: 'ap-south-1',
      },
      metaTagDescription: 'KG Diamond',
      metaTagKeywords: 'KG Diamond',
      paymentModeList: [
        {
          id: 1,
          name: 'Credit/Debit Card',
        },
        {
          id: 2,
          name: 'Net Banking',
        },
        {
          id: 3,
          name: 'Cash/Card On delivery',
        },
        {
          id: 4,
          name: 'Wallets',
        },
      ],
      searchResultExport: [
        {
          fieldName: 'stoneName',
          name: 'STONE ID',
          orderBy: 1,
        },
        {
          fieldName: 'location',
          name: 'LOC.',
          orderBy: 2,
        },
        {
          fieldName: 'ShapeCode',
          name: 'SHAPE',
          orderBy: 3,
        },
        {
          fieldName: 'Size',
          name: 'SIZE GROUP',
          orderBy: 4,
        },
        {
          fieldName: 'cts',
          name: 'CTS',
          orderBy: 5,
        },
        {
          fieldName: 'ColorCode',
          name: 'COLOR',
          orderBy: 6,
        },
        {
          fieldName: 'ClarityCode',
          name: 'CLARITY',
          orderBy: 7,
        },
        {
          fieldName: 'CutCode',
          name: 'CUT',
          orderBy: 8,
        },
        {
          fieldName: 'PolishCode',
          name: 'POL',
          orderBy: 9,
        },
        {
          fieldName: 'SymmetryCode',
          name: 'SYMM',
          orderBy: 10,
        },
        {
          fieldName: 'FluorescenceCode',
          name: 'FLUOR',
          orderBy: 11,
        },
        {
          fieldName: 'TotDepth',
          name: 'DEPTH %',
          orderBy: 12,
        },
        {
          fieldName: 'TablePer',
          name: 'TABLE %',
          orderBy: 13,
        },
        {
          fieldName: 'Length',
          name: 'LENGTH',
          orderBy: 14,
        },
        {
          fieldName: 'Width',
          name: 'WIDTH',
          orderBy: 15,
        },
        {
          fieldName: 'TotDepthMm',
          name: 'HEIGHT',
          orderBy: 16,
        },
        {
          fieldName: 'L_W',
          name: 'L/W RATIO',
          orderBy: 17,
        },
        {
          fieldName: 'Rapnet_plusDiscountPercent',
          name: 'DISC',
          orderBy: 18,
        },
        {
          fieldName: 'Rapnet_pluspercarat',
          name: 'PRICE($/ct)',
          orderBy: 19,
        },
        {
          fieldName: 'Amt',
          name: 'AMT($)',
          orderBy: 20,
        },
        {
          fieldName: 'RAPAPORTpercarat',
          name: 'RAP',
          orderBy: 21,
        },
        {
          fieldName: 'RapAmt',
          name: 'RAP VALUE',
          orderBy: 22,
        },
        {
          fieldName: 'lab',
          name: 'LAB',
          orderBy: 23,
        },
        {
          fieldName: 'ReportNo',
          name: 'REPORT NO.',
          orderBy: 24,
        },
        {
          fieldName: 'KeytoSymbolsCode',
          name: 'KEY TO SYMBOL',
          orderBy: 25,
        },
        {
          fieldName: 'ReportComments',
          name: 'REPORT COMMENTS',
          orderBy: 26,
        },
        {
          fieldName: 'LusterCode',
          name: 'LUSTER',
          orderBy: 27,
        },
        {
          fieldName: 'ShadesCode',
          name: 'SHADE',
          orderBy: 28,
        },
        {
          fieldName: 'GirdleCode',
          name: 'GIRDLE',
          orderBy: 29,
        },
        {
          fieldName: 'CrAngle',
          name: 'CROWN ANGLE',
          orderBy: 30,
        },
        {
          fieldName: 'CrHgt',
          name: 'CROWN HEIGHT',
          orderBy: 31,
        },
        {
          fieldName: 'PavAngle',
          name: 'PAVILION ANGLE',
          orderBy: 32,
        },
        {
          fieldName: 'PavHgt',
          name: 'PAVILION HEIGHT',
          orderBy: 33,
        },
        {
          fieldName: 'StarLength',
          name: 'STAR LENGTH',
          orderBy: 34,
        },
        {
          fieldName: 'LowerHalves',
          name: 'LOWER HALVES',
          orderBy: 35,
        },
        {
          fieldName: 'GirdlePer',
          name: 'GIRDLE %',
          orderBy: 36,
        },
        {
          fieldName: 'PavilionOpenInclusionCode',
          name: 'PAVILION OPEN INCLUSION',
          orderBy: 37,
        },
        {
          fieldName: 'GirdleOpenInclusionCode',
          name: 'GIRDLE OPEN INCLUSION ',
          orderBy: 38,
        },
        {
          fieldName: 'TableOpenInclusionCode',
          name: 'TABLE OPEN INCLUSION',
          orderBy: 39,
        },
        {
          fieldName: 'PavilionExtraFacetCode',
          name: 'PAVILION EXTRA FACET',
          orderBy: 40,
        },
        {
          fieldName: 'TableExtraFacetCode',
          name: 'TABLE EXTRA FACET',
          orderBy: 41,
        },
        {
          fieldName: 'SideWhiteInclusionCode',
          name: 'SIDE WHITE INCLUSION',
          orderBy: 42,
        },
        {
          fieldName: 'FluorescenceColorCode',
          name: 'FLUORESCENCE COLOR',
          orderBy: 43,
        },
        {
          fieldName: 'TableWhiteInclusionCode',
          name: 'TABLE WHITE INCLUSION',
          orderBy: 44,
        },
        {
          fieldName: 'NaturalCode',
          name: 'NATURAL',
          orderBy: 45,
        },
        {
          fieldName: 'CrownExtraFacetCode',
          name: 'CROWN EXTRA FACET ',
          orderBy: 46,
        },
        {
          fieldName: 'SideBlackInclusionCode',
          name: 'SIDE BLACK INCLUSION ',
          orderBy: 47,
        },
        {
          fieldName: 'SideSpotInclusionCode',
          name: 'SIDE SPOT INCLUSION',
          orderBy: 48,
        },
        {
          fieldName: 'TableSpotInclusionCode',
          name: 'TABLE SPOT INCLUSION',
          orderBy: 49,
        },
        {
          fieldName: 'TableBlackInclusionCode',
          name: 'TABLE BLACK INCLUSION',
          orderBy: 50,
        },
        {
          fieldName: 'CrownOpenInclusionCode',
          name: 'CROWN OPEN INCLUSION',
          orderBy: 51,
        },
        {
          fieldName: 'GrainingpdCode',
          name: 'GRAINING',
          orderBy: 52,
        },
      ],
      export: {
        param: ['cts', 'color', 'shape'],
        cartColums: {},
        productPageFields: [
          {
            fieldName: 'stoneName',
            name: 'Stone ID',
          },
          {
            fieldName: 'ReportNo',
            name: 'Report No',
          },
          {
            fieldName: 'lab',
            name: 'Lab',
          },
          {
            fieldName: 'ShapeCode',
            name: 'Shape',
          },
          {
            fieldName: 'cts',
            name: 'Size',
          },
          {
            fieldName: 'ColorCode',
            name: 'Color',
          },
          {
            fieldName: 'ClarityCode',
            name: 'Clarity',
          },
          {
            fieldName: 'CutCode',
            name: 'Cut',
          },
          {
            fieldName: 'PolishCode',
            name: 'Polish',
          },
          {
            fieldName: 'SymmetryCode',
            name: 'Symmetry',
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'Fluorescence',
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'Discount',
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: 'Price',
          },
          {
            fieldName: 'Rapnet_plus',
            name: 'Amount',
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'Rap',
          },
          {
            fieldName: 'externalStatus',
            name: 'Status',
          },
          {
            fieldName: 'location',
            name: 'Location',
          },
          {
            fieldName: 'TablePer',
            name: 'Table %',
          },
          {
            fieldName: 'TotDepth',
            name: 'Depth %',
          },
          {
            fieldName: 'Width',
            name: 'Width',
          },
          {
            fieldName: 'Length',
            name: 'Length',
          },
          {
            fieldName: 'TotDepthMm',
            name: 'Height',
          },
          {
            fieldName: 'kgStoneId',
            name: 'kgStoneId',
          },
          {
            fieldName: 'location',
            name: 'Location',
          },
          {
            fieldName: 'ShadesCode',
            name: 'Shade',
          },
          {
            fieldName: 'LusterCode',
            name: 'Luster',
          },
          {
            fieldName: 'EyeCleanCode',
            name: 'Eye Clean',
          },
          {
            fieldName: 'HeartandArrowCode',
            name: 'Heart And Arrow',
          },
          {
            fieldName: 'NaturalCode',
            name: 'Natural',
          },
          {
            fieldName: 'TotDepth',
            name: 'Total Depth %',
          },
          {
            fieldName: 'TablePer',
            name: 'Table %',
          },
          {
            fieldName: 'CrAngle',
            name: 'Cr Angle/Height',
          },
          {
            fieldName: 'PavAngle',
            name: 'Pav Angle/Depth',
          },
          {
            fieldName: 'GirdlePer',
            name: 'GIRDLE %',
          },
          {
            fieldName: 'CuletSizeCode',
            name: 'Culet',
          },
          {
            fieldName: 'GrainingCode',
            name: 'Internal Graining',
          },
          {
            fieldName: 'TableBlackInclusionCode',
            name: 'Black Table Inclusion',
          },
          {
            fieldName: 'TableWhiteInclusionCode',
            name: 'White Table Inclusion',
          },
          {
            fieldName: 'SideBlackInclusionCode',
            name: 'Side Black Inclusion',
          },
          {
            fieldName: 'SideWhiteInclusionCode',
            name: 'Side White Inclusion',
          },
          {
            fieldName: 'availableForSale',
            name: 'Availability',
          },
          {
            fieldName: 'currentLocation',
            name: 'locationId',
          },
          {
            fieldName: 'tracrId',
            name: 'tracrId',
          },
          {
            fieldName: 'L_W',
            name: 'L by W',
          },
          {
            fieldName: 'Cutwise_id',
            name: 'Cutwise_id',
          },
          {
            fieldName: 'standardShapeCode',
            name: 'standardShapeCode',
          },
          {
            fieldName: 'SideShapeCode',
            name: 'SideShapeCode',
          },
          {
            fieldName: 'AntiqueShapeCode',
            name: 'AntiqueShapeCode',
          },
          {
            fieldName: 'FancyColorCode',
            name: 'FancyColorCode',
          },
          {
            fieldName: 'FancyColorIntensityCode',
            name: 'FancyColorIntensityCode',
          },
          {
            fieldName: 'FancyColorOvertoneCode',
            name: 'FancyColorOvertoneCode',
          },
          {
            fieldName: 'ColorDescriptions',
            name: 'ColorDescriptions',
          },
          {
            fieldName: 'HandVideo',
            name: 'HandVideo',
          },
          {
            fieldName: 'TweezerVideo',
            name: 'TweezerVideo',
          },
        ],
        searchResultMobileColumns: [
          {
            fieldName: 'stoneName',
            name: 'Stone ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: '$/CT',
            type: 'integer',
            orderBy: 14,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'Disc',
            type: 'number',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 3,
          },
          {
            fieldName: 'Rapnet_plus',
            name: '$ Total',
            type: 'number',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 4,
          },
        ],
        searchResultColumns: [
          {
            fieldName: 'stoneName',
            name: 'STONE ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'location',
            name: 'LOC.',
            type: 'string',
            orderBy: 2,
            allowDeleting: false,
            showLocationTemplate: true,
          },
          {
            fieldName: 'ReportNo',
            name: 'REPORT NO.',
            type: 'string',
            orderBy: 3,
            allowDeleting: false,
            showReportTemplate: true,
            mobileViewOrder: 6,
          },
          {
            fieldName: 'ShapeCode',
            name: 'SHAPE',
            type: 'string',
            orderBy: 4,
            allowDeleting: false,
            mobileViewOrder: 11,
          },
          {
            fieldName: 'cts',
            name: 'CTS',
            type: 'number',
            orderBy: 5,
            allowDeleting: false,
            mobileViewOrder: 7,
          },
          {
            fieldName: 'ColorCode',
            name: 'COLOR',
            type: 'string',
            orderBy: 6,
            allowDeleting: false,
            mobileViewOrder: 9,
          },
          {
            fieldName: 'ClarityCode',
            name: 'CLARITY',
            type: 'string',
            orderBy: 7,
            showPopup: true,
            popupFields: 'ShapeCode,cts,ColorCode',
            allowDeleting: false,
            mobileViewOrder: 10,
          },
          {
            fieldName: 'lab',
            name: 'LAB',
            type: 'string',
            orderBy: 8,
            allowDeleting: false,
            mobileViewOrder: 12,
          },
          {
            fieldName: 'CutCode',
            name: 'CUT',
            type: 'string',
            orderBy: 9,
            allowDeleting: false,
            mobileViewOrder: 13,
          },
          {
            fieldName: 'PolishCode',
            name: 'POL',
            type: 'string',
            orderBy: 10,
            allowDeleting: false,
            mobileViewOrder: 14,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'SYMM',
            type: 'string',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 15,
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'FLUOR',
            type: 'string',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 16,
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'DISC',
            type: 'number',
            orderBy: 13,
            allowDeleting: false,
            mobileViewOrder: 17,
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: 'PRICE($)',
            type: 'number',
            orderBy: 14,
            allowDeleting: false,
            mobileViewOrder: 18,
          },
          {
            fieldName: 'Rapnet_plus',
            name: 'AMT($)',
            type: 'number',
            orderBy: 15,
            allowDeleting: false,
            mobileViewOrder: 19,
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'RAP',
            type: 'number',
            orderBy: 16,
            allowDeleting: false,
            mobileViewOrder: 20,
          },
          {
            fieldName: 'RapAmt',
            name: 'RAP VALUE',
            type: 'number',
            orderBy: 17,
            allowDeleting: false,
            mobileViewOrder: 3,
          },
          {
            fieldName: 'Length',
            name: 'LENGTH',
            type: 'number',
            orderBy: 18,
            allowDeleting: false,
            mobileViewOrder: 4,
          },
          {
            fieldName: 'Width',
            name: 'WIDTH',
            type: 'number',
            allowDeleting: true,
            orderBy: 19,
            mobileViewOrder: 5,
          },
          {
            fieldName: 'TotDepthMm',
            name: 'HEIGHT',
            type: 'integer',
            orderBy: 20,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
          {
            fieldName: 'TotDepth',
            name: 'DEPTH %',
            type: 'string',
            orderBy: 21,
            allowDeleting: false,
          },
          {
            fieldName: 'TablePer',
            name: 'TABLE %',
            type: 'string',
            orderBy: 22,
            allowDeleting: false,
          },
          {
            fieldName: 'L_W',
            name: 'L/W RATIO',
            type: 'string',
            orderBy: 23,
          },
          {
            fieldName: 'KeytoSymbolsCode',
            name: 'KEY TO SYMBOL',
            orderBy: 24,
          },
          {
            fieldName: 'ReportComments',
            name: 'REPORT COMMENTS',
            orderBy: 25,
          },
          {
            fieldName: 'LusterCode',
            name: 'LUSTER',
            orderBy: 26,
          },
          {
            fieldName: 'ShadesCode',
            name: 'SHADE',
            orderBy: 27,
          },
          {
            fieldName: 'GirdleCode',
            name: 'GIRDLE',
            orderBy: 28,
          },
          {
            fieldName: 'CrAngle',
            name: 'CROWN ANGLE',
            orderBy: 29,
          },
          {
            fieldName: 'CrHgt',
            name: 'CROWN HEIGHT',
            orderBy: 30,
          },
          {
            fieldName: 'PavAngle',
            name: 'PAVILION ANGLE',
            orderBy: 31,
          },
          {
            fieldName: 'PavHgt',
            name: 'PAVILION HEIGHT',
            orderBy: 32,
          },
          {
            fieldName: 'StarLength',
            name: 'STAR LENGTH',
            orderBy: 33,
          },
          {
            fieldName: 'LowerHalves',
            name: 'LOWER HALVES',
            orderBy: 34,
          },
          {
            fieldName: 'GirdlePer',
            name: 'GIRDLE %',
            orderBy: 35,
          },
          {
            fieldName: 'PavilionOpenInclusionCode',
            name: 'PAVILION OPEN INCLUSION',
            orderBy: 36,
          },
          {
            fieldName: 'GirdleOpenInclusionCode',
            name: 'GIRDLE OPEN INCLUSION ',
            orderBy: 37,
          },
          {
            fieldName: 'TableOpenInclusionCode',
            name: 'TABLE OPEN INCLUSION',
            orderBy: 38,
          },
          {
            fieldName: 'PavilionExtraFacetCode',
            name: 'PAVILION EXTRA FACET',
            orderBy: 39,
          },
          {
            fieldName: 'TableExtraFacetCode',
            name: 'TABLE EXTRA FACET',
            orderBy: 40,
          },
          {
            fieldName: 'SideWhiteInclusionCode',
            name: 'SIDE WHITE INCLUSION',
            orderBy: 41,
          },
          {
            fieldName: 'FluorescenceColorCode',
            name: 'FLUORESCENCE COLOR',
            orderBy: 42,
          },
          {
            fieldName: 'TableWhiteInclusionCode',
            name: 'TABLE WHITE INCLUSION',
            orderBy: 43,
          },
          {
            fieldName: 'NaturalCode',
            name: 'NATURAL',
            orderBy: 44,
          },
          {
            fieldName: 'CrownExtraFacetCode',
            name: 'CROWN EXTRA FACET ',
            orderBy: 45,
          },
          {
            fieldName: 'SideBlackInclusionCode',
            name: 'SIDE BLACK INCLUSION ',
            orderBy: 46,
          },
          {
            fieldName: 'SideSpotInclusionCode',
            name: 'SIDE SPOT INCLUSION',
            orderBy: 47,
          },
          {
            fieldName: 'TableSpotInclusionCode',
            name: 'TABLE SPOT INCLUSION',
            orderBy: 48,
          },
          {
            fieldName: 'TableBlackInclusionCode',
            name: 'TABLE BLACK INCLUSION',
            orderBy: 49,
          },
          {
            fieldName: 'CrownOpenInclusionCode',
            name: 'CROWN OPEN INCLUSION',
            orderBy: 50,
          },
          {
            fieldName: 'GrainingCode',
            name: 'GRAINING',
            orderBy: 51,
          },
        ],
        orderPageColumns: [
          {
            fieldName: 'stoneName',
            name: 'STONE ID',
            type: 'string',
            orderBy: 1,
            redirectToDetailPage: true,
            allowDeleting: false,
          },
          {
            fieldName: 'unitPrice',
            name: 'RAP',
            type: 'number',
            orderBy: 2,
            allowDeleting: false,
          },
          {
            fieldName: 'purchasedAtDiscount',
            name: 'LIST DISC',
            type: 'number',
            orderBy: 3,
            allowDeleting: false,
          },
          {
            fieldName: 'purchasedAtPrice',
            name: 'LIST PRICE',
            type: 'number',
            orderBy: 4,
            allowDeleting: false,
          },
          {
            fieldName: 'purchasedAtAmount',
            name: 'LIST AMT',
            type: 'number',
            orderBy: 5,
            allowDeleting: false,
          },
          {
            fieldName: 'listDiscount',
            name: 'KG DISC',
            type: 'number',
            orderBy: 6,
            allowDeleting: false,
          },
          {
            fieldName: 'listDiscountPrice',
            name: 'KG PRICE',
            type: 'number',
            orderBy: 7,
            allowDeleting: false,
          },
          {
            fieldName: 'listAmount',
            name: 'KG AMT',
            type: 'number',
            orderBy: 8,
            allowDeleting: false,
          },
          {
            fieldName: 'ColorCode',
            name: 'COLOR',
            type: 'string',
            orderBy: 12,
            allowDeleting: false,
          },
          {
            fieldName: 'ClarityCode',
            name: 'CLARITY',
            type: 'string',
            orderBy: 13,
            allowDeleting: false,
          },
          {
            fieldName: 'CutCode',
            name: 'CUT',
            type: 'string',
            orderBy: 14,
            allowDeleting: false,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'SYMMETRY',
            type: 'string',
            orderBy: 15,
            allowDeleting: false,
          },
          {
            fieldName: 'PolishCode',
            name: 'POLISH',
            type: 'string',
            orderBy: 16,
            allowDeleting: false,
          },
          {
            fieldName: 'location',
            name: 'LOC.',
            type: 'string',
            orderBy: 15,
            allowDeleting: false,
            showLocationTemplate: true,
          },
        ],
        offerPageColumns: [
          {
            fieldName: 'stoneName',
            name: 'STONE ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'lab',
            name: 'LAB',
            type: 'string',
            orderBy: 2,
            allowDeleting: false,
            mobileViewOrder: 6,
          },
          {
            fieldName: 'ShapeCode',
            name: 'SHAPE',
            type: 'string',
            orderBy: 3,
            allowDeleting: false,
            mobileViewOrder: 7,
          },
          {
            fieldName: 'quantity',
            name: 'CTS',
            type: 'number',
            orderBy: 4,
            allowDeleting: false,
            mobileViewOrder: 8,
          },
          {
            fieldName: 'ColorCode',
            name: 'COLOR',
            type: 'string',
            orderBy: 5,
            allowDeleting: false,
            mobileViewOrder: 9,
          },
          {
            fieldName: 'ClarityCode',
            name: 'CLARITY',
            type: 'string',
            orderBy: 6,
            allowDeleting: false,
            mobileViewOrder: 10,
          },
          {
            fieldName: 'CutCode',
            name: 'CUT',
            type: 'string',
            orderBy: 7,
            allowDeleting: false,
            mobileViewOrder: 11,
          },
          {
            fieldName: 'PolishCode',
            name: 'POLISH',
            type: 'string',
            orderBy: 8,
            allowDeleting: false,
            mobileViewOrder: 12,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'SYMMETRY',
            type: 'string',
            orderBy: 9,
            allowDeleting: false,
            mobileViewOrder: 13,
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'FLUORESCENCE',
            type: 'string',
            orderBy: 10,
            allowDeleting: false,
            mobileViewOrder: 14,
          },
          {
            fieldName: 'listDiscount',
            name: 'KG Counter Offer Disc',
            type: 'number',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 15,
          },
          {
            fieldName: 'listDiscountPrice',
            name: 'KG Counter Offer Price($/ct)',
            type: 'number',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 16,
          },
          {
            fieldName: 'listAmount',
            name: 'KG Counter Offer Amt($)',
            type: 'number',
            orderBy: 13,
            allowDeleting: false,
            mobileViewOrder: 17,
          },
          {
            fieldName: 'Req Discount',
            name: 'Offer Disc',
            type: 'number',
            orderBy: 14,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 3,
          },
          {
            fieldName: 'Req Price',
            name: 'Offer Price($/ct)',
            type: 'number',
            orderBy: 15,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 4,
          },
          {
            fieldName: 'Amount',
            name: 'Offer Amt($)',
            type: 'number',
            orderBy: 16,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 5,
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'KG Disc',
            type: 'number',
            orderBy: 17,
            allowDeleting: false,
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: 'KG Price($/ct)',
            type: 'number',
            orderBy: 18,
            allowDeleting: false,
          },
          {
            fieldName: 'Rapnet_plus',
            name: 'Kg Amt($)',
            type: 'number',
            orderBy: 19,
            allowDeleting: false,
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'Rap',
            type: 'number',
            orderBy: 20,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
        ],
        manageOfferDetailPageColumns: [
          {
            fieldName: 'stoneName',
            name: 'Stone ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'lab',
            name: 'Lab',
            type: 'string',
            orderBy: 2,
            allowDeleting: false,
            mobileViewOrder: 6,
          },
          {
            fieldName: 'ShapeCode',
            name: 'Shape',
            type: 'string',
            orderBy: 3,
            allowDeleting: false,
            mobileViewOrder: 7,
          },
          {
            fieldName: 'quantity',
            name: 'CTS',
            type: 'number',
            orderBy: 4,
            allowDeleting: false,
            mobileViewOrder: 8,
          },
          {
            fieldName: 'ColorCode',
            name: 'Color',
            type: 'string',
            orderBy: 5,
            allowDeleting: false,
            mobileViewOrder: 9,
          },
          {
            fieldName: 'ClarityCode',
            name: 'Clarity',
            type: 'string',
            orderBy: 6,
            allowDeleting: false,
            mobileViewOrder: 10,
          },
          {
            fieldName: 'CutCode',
            name: 'Cut',
            type: 'string',
            orderBy: 7,
            allowDeleting: false,
            mobileViewOrder: 11,
          },
          {
            fieldName: 'PolishCode',
            name: 'Polish',
            type: 'string',
            orderBy: 8,
            allowDeleting: false,
            mobileViewOrder: 12,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'Symmetry',
            type: 'string',
            orderBy: 9,
            allowDeleting: false,
            mobileViewOrder: 13,
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'Fluorescence',
            type: 'string',
            orderBy: 10,
            allowDeleting: false,
            mobileViewOrder: 14,
          },
          {
            fieldName: 'listDiscount',
            name: 'KG Counter Offer Disc',
            type: 'number',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 15,
          },
          {
            fieldName: 'listDiscountPrice',
            name: 'KG Counter Offer Price($/ct)',
            type: 'number',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 16,
          },
          {
            fieldName: 'listAmount',
            name: 'KG Counter Offer Amt($)',
            type: 'number',
            orderBy: 13,
            allowDeleting: false,
            mobileViewOrder: 17,
          },
          {
            fieldName: 'discount',
            name: 'Offer Disc',
            type: 'number',
            orderBy: 14,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 3,
          },
          {
            fieldName: 'discountPrice',
            name: 'Offer Price($/ct)',
            type: 'number',
            orderBy: 15,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 4,
          },
          {
            fieldName: 'priceWithShipCost',
            name: 'Offer Amt($)',
            type: 'number',
            orderBy: 16,
            allowUpdating: true,
            allowDeleting: false,
            editorOptions: {
              format: 'number',
            },
            mobileViewOrder: 5,
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'KG Disc',
            type: 'number',
            orderBy: 17,
            allowDeleting: false,
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: 'KG Price($/ct)',
            type: 'number',
            orderBy: 18,
            allowDeleting: false,
          },
          {
            fieldName: 'Rapnet_plus',
            name: 'Kg Amt($)',
            type: 'number',
            orderBy: 19,
            allowDeleting: false,
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'Rap',
            type: 'number',
            orderBy: 20,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
        ],
        manageOrderDetailPageColumns: [
          {
            fieldName: 'stoneName',
            name: 'STONE ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'lab',
            name: 'LAB',
            type: 'string',
            orderBy: 2,
            allowDeleting: false,
            mobileViewOrder: 6,
          },
          {
            fieldName: 'ShapeCode',
            name: 'SHAPE',
            type: 'string',
            orderBy: 3,
            allowDeleting: false,
            mobileViewOrder: 7,
          },
          {
            fieldName: 'quantity',
            name: 'CTS',
            type: 'number',
            orderBy: 4,
            allowDeleting: false,
            mobileViewOrder: 8,
          },
          {
            fieldName: 'ColorCode',
            name: 'COLOR',
            type: 'string',
            orderBy: 5,
            allowDeleting: false,
            mobileViewOrder: 9,
          },
          {
            fieldName: 'ClarityCode',
            name: 'CLARITY',
            type: 'string',
            orderBy: 6,
            allowDeleting: false,
            mobileViewOrder: 10,
          },
          {
            fieldName: 'CutCode',
            name: 'CUT',
            type: 'string',
            orderBy: 7,
            allowDeleting: false,
            mobileViewOrder: 11,
          },
          {
            fieldName: 'PolishCode',
            name: 'POLISH',
            type: 'string',
            orderBy: 8,
            allowDeleting: false,
            mobileViewOrder: 12,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'SYMMETRY',
            type: 'string',
            orderBy: 9,
            allowDeleting: false,
            mobileViewOrder: 13,
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'FLUORESCENCE',
            type: 'string',
            orderBy: 10,
            allowDeleting: false,
            mobileViewOrder: 14,
          },
          {
            fieldName: 'discount',
            name: 'PURCHASE DISCOUNT',
            type: 'number',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 3,
          },
          {
            fieldName: 'discountPrice',
            name: 'PURCHASE PRICE',
            type: 'number',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 4,
          },
          {
            fieldName: 'totalDiscountPrice',
            name: 'PURCHASE AMOUNT',
            type: 'number',
            allowDeleting: true,
            orderBy: 13,
            mobileViewOrder: 5,
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'RAP',
            type: 'integer',
            orderBy: 14,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
        ],
        manageOrderPageColumns: [
          {
            fieldName: 'stoneName',
            name: 'STONE ID',
            type: 'string',
            orderBy: 1,
            allowDeleting: false,
            showStoneTemplate: true,
            mobileViewOrder: 1,
          },
          {
            fieldName: 'lab',
            name: 'LAB',
            type: 'string',
            orderBy: 2,
            allowDeleting: false,
            mobileViewOrder: 6,
          },
          {
            fieldName: 'ShapeCode',
            name: 'SHAPE',
            type: 'string',
            orderBy: 3,
            allowDeleting: false,
            mobileViewOrder: 7,
          },
          {
            fieldName: 'quantity',
            name: 'CTS',
            type: 'number',
            orderBy: 4,
            allowDeleting: false,
            mobileViewOrder: 8,
          },
          {
            fieldName: 'ColorCode',
            name: 'COLOR',
            type: 'string',
            orderBy: 5,
            allowDeleting: false,
            mobileViewOrder: 9,
          },
          {
            fieldName: 'ClarityCode',
            name: 'CLARITY',
            type: 'string',
            orderBy: 6,
            allowDeleting: false,
            mobileViewOrder: 10,
          },
          {
            fieldName: 'CutCode',
            name: 'CUT',
            type: 'string',
            orderBy: 7,
            allowDeleting: false,
            mobileViewOrder: 11,
          },
          {
            fieldName: 'PolishCode',
            name: 'POLISH',
            type: 'string',
            orderBy: 8,
            allowDeleting: false,
            mobileViewOrder: 12,
          },
          {
            fieldName: 'SymmetryCode',
            name: 'SYMMETRY',
            type: 'string',
            orderBy: 9,
            allowDeleting: false,
            mobileViewOrder: 13,
          },
          {
            fieldName: 'FluorescenceCode',
            name: 'FLUORESCENCE',
            type: 'string',
            orderBy: 10,
            allowDeleting: false,
            mobileViewOrder: 14,
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            name: 'PURCHASE DISCOUNT',
            type: 'number',
            orderBy: 11,
            allowDeleting: false,
            mobileViewOrder: 3,
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            name: 'PURCHASE PRICE($/ct)',
            type: 'number',
            orderBy: 12,
            allowDeleting: false,
            mobileViewOrder: 4,
          },
          {
            fieldName: 'Rapnet_plus',
            name: 'PURCHASE AMOUNT($)',
            type: 'number',
            allowDeleting: true,
            orderBy: 13,
            mobileViewOrder: 5,
          },
          {
            fieldName: 'RAPAPORTpercarat',
            name: 'RAP',
            type: 'integer',
            orderBy: 14,
            allowDeleting: false,
            mobileViewOrder: 2,
          },
        ],
        exportColumns: {},
        totalSummaryForManageOfferDetails: [
          {
            fieldName: 'RAPAPORTpercarat',
            summaryType: 'sum',
          },
          {
            fieldName: 'listDiscount',
            summaryType: 'avg',
          },
          {
            fieldName: 'listDiscountPrice',
            summaryType: 'avg',
          },
          {
            fieldName: 'listAmount',
            summaryType: 'sum',
          },
          {
            fieldName: 'discount',
            summaryType: 'avg',
          },
          {
            fieldName: 'discountPrice',
            summaryType: 'avg',
          },
          {
            fieldName: 'priceWithShipCost',
            summaryType: 'sum',
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            summaryType: 'avg',
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            summaryType: 'avg',
          },
          {
            fieldName: 'Rapnet_plus',
            summaryType: 'sum',
          },
        ],
        totalSummaryForManageOrderDetails: [
          {
            fieldName: 'RAPAPORTpercarat',
            summaryType: 'sum',
          },
          {
            fieldName: 'discount',
            summaryType: 'avg',
          },
          {
            fieldName: 'discountPrice',
            summaryType: 'avg',
          },
          {
            fieldName: 'totalDiscountPrice',
            summaryType: 'sum',
          },
        ],
        totalSummary: [
          {
            fieldName: 'quantity',
            summaryType: 'sum',
          },
          {
            fieldName: 'cts',
            summaryType: 'sum',
          },
          {
            fieldName: 'Req Discount',
            summaryType: 'avg',
          },
          {
            fieldName: 'Req Price',
            summaryType: 'custom',
          },
          {
            fieldName: 'Amount',
            summaryType: 'sum',
          },
          {
            fieldName: 'listDiscount',
            summaryType: 'avg',
          },
          {
            fieldName: 'listDiscountPrice',
            summaryType: 'avg',
          },
          {
            fieldName: 'listAmount',
            summaryType: 'sum',
          },
          {
            fieldName: 'RAPAPORTpercarat',
            summaryType: 'sum',
          },
          {
            fieldName: 'Rapnet_plusDiscountPercent',
            summaryType: 'avg',
          },
          {
            fieldName: 'Rapnet_pluspercarat',
            summaryType: 'avg',
          },
          {
            fieldName: 'Rapnet_plus',
            summaryType: 'sum',
          },
        ],
        emailColums: ['cts', 'color', 'shape'],
      },
      shortCodes: [
        {
          label: 'POOR',
          code: 'PR',
        },
        {
          label: 'FAIR',
          code: 'FR',
        },
        {
          label: 'GOOD',
          code: 'GD',
        },
        {
          label: 'VGOOD',
          code: 'VG',
        },
        {
          label: 'EXCL',
          code: 'EX',
        },
        {
          label: 'IDEAL',
          code: 'ID',
        },
      ],
      googleAnalyticsID: 'G-DMLW1FFLHQ',
      favicon:
        'https://img.mobioffice.io/api/containers/37/download/0be9bc32-dc24-4702-8927-9b1b2b24b8e5.png',
      razorpay: {
        public: 'rzp_live_7bewAkmGBaZlNe',
      },
      MaximumLimit: 5000,
      sendBroadcastMsgTalkbrite: 'userMappings/sendBroadcastMsgTalkbrite',
      showDescriptionOnProductDetail: false,
      showCheckDeliveryOnProductDetail: false,
      footer:
        "<table class='w100 ffWhitney clsMainData'> <tr> <ul class='kgLiNode tal' > <li class='kgFooterLi' ><a href='/page-contents?title=About'>About</a></li> <li class='kgFooterLi' ><a href='/page-contents?title=Process'>Process</a></li> <li class='kgFooterLi' ><a href='/page-contents?title=Legacy'>Legacy</a></li> <li class='kgFooterLi' ><a href='/page-contents?title=Contact'>Contact</a></li> </ul> </td></tr> </table>",
      footerLinks: [
        {
          title: 'About',
          redirectTo: '/page-contents?title=About',
          data: "<div class='row'> <div class='diamond-div hideInSmall'> <div class='tac'> <div class='diamond-image' > </div> </div> </div> <div class='about-div'> <h1 class='title'> About Us </h1> <div class='pb-pt-10'>KG Diamonds is the diamond distribution portal of K Girdharlal. We cater to diamond dealers, jewelry manufacturers and retailers through: <ol> <li>On-demand fulfillment from our extensive merchandise</li> <li>Reliable manufacturing of pre-ordered diamonds according to requisites</li> <li>Live inventory feed through API or FTP</li> </ol> We have a service centre in New York, Antwerp, Hong Kong, Mumbai, and Dubai – out of which we provide customers with an omni-channel experience. During Covid19, we redesigned our digital portal to create a streamlined purchasing experience for you. Our polished diamonds profile focus on the following:</div> </div> </div> <div class='mtp50'> </div> <div class='row-bg mtp50 '> <div class='md hydrated brand-col fl'> <div class='brandStatement'> Brand <br /> Statement </div> </div> <div class='md hydrated mauto tal fl'> <div class='brand-content'> </div> </div> </div> <div class='row mar40'> <div class='column tac-wc fl'> <div class='diamond-content'> <h2 class='sub-title'> Certified Round & Fancy 0.7 - 0.8 </h2> <div class='pb-pt-10 desc'> While we produce diamonds in all shapes and sizes, most of our production lies between 0.70 and 3.00 carats. In this size range, we can provide all shapes and cutting styles. </div> </div> </div>  <div class='row mar40'> <div class='column tac-wc fl'> <div class='diamond-content'> <h2 class='sub-title'> Forever Diamond Signature </h2> <div class='pb-pt-10 desc'> We offer Forevermark certified Round & Fancy Shapes from 0.08carats.In addition, we also produce and distribute Black Label Rounds to approved network of retailers and dealers. </div> </div> </div> <div class='column tac-wc fl'> <div class='diamond-content'> <h2 class='sub-title'>Precision Hearts & Diamond Cuts</h2> <div class='pb-pt-10 desc'> One of KG Diamonds’ niche is to service businesses with finer taste in cutting style and precision. This includes strict Heart & Arrow Rounds, and Ideal make Oval, Princess, Cushion, and Emerald Cuts. </div> </div> </div> </div>",
        },
        {
          title: 'Process',
          redirectTo: '/page-contents?title=Process',
          data: "<div class='row'> <div class='diamond-div hideInSmall'> <div class='tac'>  <div class='diamond-image'> </div>  </div>  </div> <div class='about-div'>  <h1 class='title'> Process </h1> <div class='pb-pt-10'> <p>K. Girdharlal, better known as KG, was established in 1967 as a diamond trader. It was in the early 1990’s that we turned our focus to cutting and polishing diamonds in India’s diamond capital, Surat. We are now proudly one of India’s leading diamond manufacturers, housed in the industry’s first Platinum facility rated by the Indian Green Building Council (IGBC). </p> <p> The company is still family run with an extensive reach across the entire supply chain and is represented in each of the main diamond centers. With over 1,500 employees across the globe, we all share the singular vision of being the world’s most efficient and effective diamond polishing and distribution company.</p>              <p> As a family concern, we are proud to have our fourth generation entering the business. Our core values remain as true today as they were when we started in 1967, in that “there is more to making diamonds”.We strive to keep achieving benefits for our employees, clients, partners, society, and environment. </div> </div> </div>",
        },
        {
          title: 'Legacy',
          redirectTo: '/page-contents?title=Legacy',
          data: " <div class='row'><div class='diamond-div hideInSmall'>  <div class='tac'> <div class='diamond-image'> </div></div> </div><div class='about-div'>  <h1 class='title'> Legacy </h1> <div class='pb-pt-10'> <p> Producing across many shapes and sizes for predetermined orders and having extensive available  merchandise available at the right time is a model derived from deep preparation along the pipeline.              </p>              <h4 class='ul'> Rough Procurement </h4>              <p> G attains consistent rough diamonds originating from De Beers and Alrosa mines. This stable source of  rough allows the company to plan upcoming polished diamond orders for long term projects as well as keep healthy inventory levels throughout the year. </p> <h4 class='ul'> Polishing Infrastructure</h4>              <p> The company’s heart lies in its 9300m2 built up LEEDS platinum rated factory named 'KG House'. It is                home to more than 1,500 minds that view the company as an employer of choice owing to its stable, safe, and comfortable work environment. The House proudly reimburses employees far above the industry average and go beyond the basics to ensure good health and happiness from ground up. </p> <p> With ongoing process R&D taking place throughout the facility, KG House ensures deriving the highest value on each stone in the most efficient way. This is achieved with the use of the latest manufacturing technology and an in-house software team that allows process to adapt extremely fast for a particular                order, stone, or general changes. The facility also hosts a diamond development team, that services custom shape design with long term clients. To ensure timely delivery for order-based production, the                House has a dedicated Program Fulfillment team. The synergy of the various teams integrated with our                planning and polishing departments result in very high fulfillment levels for client orders. </p>              <h4 class='ul'> Distribution Points </h4>              <p> To facilitate seamless delivery and a high service level, we have distribution points present in: </p>              <ol>                <li> New York </li>                <li> Antwerp </li>                <li> Hong Kong </li>                <li> Mumbai </li>                <li> Dubai </li>              </ol>              <p> Members based in the distribution offices bridge the gap between clients and the factory to                communicate order requirements down to the smallest of details. Moreover, the distribution offices                signal the factory for market trends to ensure relevant inventory is available when needed. </p>  </div> </div> </div> ",
        },
        {
          title: 'Contact',
          redirectTo: '/page-contents?title=Contact',
          data: "<div class='row'>  <div class='diamond-div hideInSmall'><div class='tac'>  <div class='diamond-image'> </div>  </div> </div> <div class='about-div'>  <h1 class='title'> Contact </h1>  <div class='pb-pt-10 tac'> <p >  EC9011/ 12, Bharat Diamond Bourse </p><p>  Mumbai 400051, Maharashtra, India  </p><p>  +912269103333 </p><p> info@kgirdharlal.com </p> </div> </div> </div>",
        },
      ],
      homePageHeaderLinks: [],
      loggedInUserHeaderLinks: [
        {
          icon: 'search',
          title: 'Search',
          redirectTo: '/diamond-search',
        },
        {
          title: 'Offers',
          redirectTo: '/orders/All?ob=Offer',
        },
        {
          title: 'Layouts',
          redirectTo: '/layouts',
        },
        {
          title: 'Orders',
          redirectTo: '/orders/All',
        },
      ],
      viewLoggingEnabled: true,
      productPage: 'ProductPage',
      getRecentProducts: true,
      getLatestReviews: true,
      SMSConfig: {
        senderID: 'ATSNDR',
        LRProcess: false,
        Broadcast: false,
        LoginNotification: false,
        placeOrder: true,
      },
      sendEmailOnPlaceOrder: true,
      atisundarOrderCopy: true,
      showHeaderOnHomePage: true,
      showLoginAsGuest: false,
      showSchemes: false,
      ShowDispatches: false,
      ShowNeworders: false,
      ShowCartPage: true,
      productListing: 'grid',
      productName: 'Carats',
      currency: '$',
      pickupUserId: '108367',
      emailFrom: 'noreply@kgirdharlal.com',
      customLinkPrefix: 'http://diamondbiography.com/shared/',
      externalProduct: {
        partyWiseRequisitionStones:
          'https://dev-api.lattice-node-service.mobioffice.io/users/partyWiseRequisitionStones',
        external: 'lattice',
        url: 'https://dev-api.lattice.mobioffice.io/master-service/api/stone/findByStoneIdsAndParams',
        pdParameterUrl:
          'https://dev-api.lattice.mobioffice.io/master-service/api/company_sspd_settings/findAllByCompany?transType=SS',
        request: {
          default:
            'https://dev-api.lattice.mobioffice.io/master-service/api/stone/requestFromTalkbrite',
          Offer:
            'https://dev-api.lattice.mobioffice.io/master-service/api/negotiation_master/negotiationFromTalkbrite',
          OfferApproval:
            'https://dev-api.lattice.mobioffice.io/master-service/api/negotiation_master/approveOfferFromTalkbrite',
          salesPersonUrl:
            'https://dev-api.lattice-node-service.mobioffice.io/users/getUserDetailByUsername',
          excelExportUrl:
            'https://dev-api.lattice.mobioffice.io/master-service/api/template/exportStockFromKgWebsite',
          createShareLink:
            'https://dev-api.lattice.mobioffice.io/master-service/api/stone/emailTalkbriteLink',
        },
        price: 'RAPAPORTpercarat',
        defaultQty: 'cts',
        discount: 'Rapnet_plusDiscountPercent',
        kgAppliedDiscount: 'Rapnet_plusDiscountPercent',
        kgAppliedPrice: 'Rapnet_pluspercarat',
        kgAppliedAmount: 'Rapnet_plus',
        mixpanelToken: 'fc3fc09654186a4185188a36f2da2b2f',
        excludeParameters: [
          'SPMpercarat',
          'SPMDiscountPercent',
          'SPM',
          'SPMWithPDDiscountPercent',
          'SPMpercarat',
          'SPMWithPD',
          'Rapnet_OrgDiscountPercent',
          'Rapnet_Orgpercarat',
          'Rapnet_Org',
          'BASEPDDiscountPercent',
          'BASEPDpercarat',
          'BASEPD',
          'PPriceAmt',
          'SPMWithPDActualPrice',
          'AvgStandardPrice',
          'MumbaiMfgAmtAvgActualPrice',
          'SPMActualPrice',
          'SPMStandardPrice',
          'SPMWithPDStandardPrice',
          'SPMWithPDpercarat',
          'AssortDiscountPercent',
          'Assortpercarat',
          'Avg',
          'PPricepercts',
          'Rapnet_OrgActualPrice',
          'Rapnet_OrgStandardPrice',
          'Rapnet_plusActualPrice',
          'Rapnet_plusStandardPrice',
          'otherOfficePriceAmt',
          'otherOfficePricepercarat',
          'otherOfficePriceDiscount',
          'AvgActualPrice',
          'AvgDiscountPercent',
          'AvgDiscountPercent',
          'Avgpercarat',
          'BASEPDActualPrice',
          'BASEPDStandardPrice',
        ],
        login: {
          url: 'https://dev-api.lattice.mobioffice.io/user-service/api/user/login',
          json: {
            username: 'talkbrite',
            password: 'talkbrite123',
            companyName: 'mumbai',
            appName: 'lattice',
          },
        },
        updateUser:
          'https://dev-api.lattice.mobioffice.io/master-service/api/party_master/addUpdatePartyWithPendingApprovalFromWebsite',
        RemoveOrder: {
          default:
            'https://dev-api.lattice.mobioffice.io/master-service/api/stone/deleteRequestFromTalkbrite',
          Offer:
            'https://dev-api.lattice.mobioffice.io/master-service/api/negotiation_master/rejectOfferFromTalkbrite',
        },
        VoucherUpdate:
          'https://dev-api.lattice.mobioffice.io/master-service/api/voucher/updateVoucherRequestFromTalkbrite',
      },
      searchPageButtons: [
        {
          name: 'Add To Cart',
          action: '/my-cart',
          orderBook: '',
        },
        {
          name: 'Purchase',
          action: 'order',
          orderBook: '',
        },
        {
          name: 'Virtual Inspection',
          action: 'Virtual Inspection',
          orderBook: '',
        },
        {
          name: 'List View',
          action: 'List View',
          orderBook: '',
        },
        {
          name: 'Book Appointment',
          action: 'Schedule Viewing',
          orderBook: 'Appointment',
        },
        {
          name: 'Submit Offer Bid',
          action: '/my-cart?ob=Offer',
          orderBook: 'Offer',
        },
      ],
      cartPageButton: [
        {
          name: 'Purchase',
          action: 'order',
          orderBook: 'order',
        },
        {
          name: 'Virtual Inspection',
          action: 'Virtual Inspection',
          orderBook: '',
        },
        {
          name: 'List View',
          action: 'List View',
          orderBook: '',
        },
      ],
      cartOfferButton: [
        {
          name: 'Save Offer',
          action: 'add',
          orderBook: 'Offer',
        },
        {
          name: 'Remove',
          action: 'cancel',
          orderBook: 'Offer',
        },
      ],
      orderPageDetailButton: [
        {
          name: 'Purchase',
          action: 'purchase',
          orderBook: 'Offer',
        },
        {
          name: 'Update Offer',
          action: 'update',
          orderBook: 'Offer',
        },
        {
          name: 'Remove Offer',
          action: 'remove',
          orderBook: 'Offer',
        },
      ],
      orderPageButton: [
        {
          name: 'Update Appointment',
          action: 'order',
          orderBook: 'Appointment',
        },
        {
          name: 'Remove Appointment',
          action: 'order',
          orderBook: 'Appointment',
        },
        {
          name: 'Remove Offer',
          action: 'order',
          orderBook: 'Offer',
        },
        {
          name: 'Cancel Order',
          action: 'order',
          orderBook: 'Orders',
        },
        {
          name: 'Cancel Memo',
          action: 'order',
          orderBook: 'Memo',
        },
        {
          name: 'test',
          action: 'order',
          orderBook: 'Order',
        },
      ],
      memoDays: [
        {
          display: '10 Days',
          value: 10,
        },
        {
          display: '30 Days',
          value: 30,
        },
        {
          display: '60 Days',
          value: 60,
        },
        {
          display: '120 Days',
          value: 120,
        },
      ],
      addressTypes: [
        {
          name: 'Delivery',
          value: 'Delivery',
          selected: 'true',
        },
        {
          name: 'Pick Up',
          value: 'Pick Up',
          selected: 'false',
        },
      ],
      companyTypes: [
        {
          name: 'Retailer',
          selected: false,
        },
        {
          name: 'Dealer',
          selected: false,
        },
        {
          name: 'Jewelery Mfg',
          selected: false,
        },
        {
          name: 'Broker',
          selected: false,
        },
        {
          name: 'Consumer',
          selected: false,
        },
        {
          name: 'Other',
          selected: false,
        },
      ],
      sideMenuList: [
        {
          type: 'searchInput',
        },
        {
          type: 'listView',
          list: [
            {
              name: 'Adjust Filters',
              redirectTo: '/diamond-search',
            },
          ],
        },
        {
          type: 'language',
          list: [{ name: 'Select Language' }],
        },
        {
          type: 'listView',
          list: [
            {
              name: 'Cart',
              redirectTo: '/my-cart',
            },
            {
              name: 'Past Orders',
              redirectTo: '/orders/All',
            },
          ],
        },
        {
          type: 'listView',
          list: [
            {
              name: 'Profile',
            },
            {
              name: 'Logout',
            },
          ],
        },
      ],
      KYCrequired: true,
      redirectAfterLogin: 'diamond-search',
      shipmentNotes: {
        html: "<div class='shipingNote'> <ul class='list'> <li class='item'>Need to keep clear note: “Your Account Manager will share actual shipping charges upon confirmation.” <li class='item'>Count of overseas shipment = count of stone location counthy in the business that do not equal delivery or pick up counthy</li> </li> </ul> <table> <tr> <th class='border-eee p5 d-hotline'> ESTIMATED SHIPPING CHARGES </th> <th class='border-eee p5 d-hotline'> Delivery </th> <th class='border-eee p5 d-hotline'> Pick Up </th> </tr> <tr> <th class='border-eee p5 d-hotline'> Standard </th> <th class='border-eee p5 cardHeader'> $100 </th> <th class='border-eee p5 cardHeader'> 0 </th> </tr> <tr> <th class='border-eee p5 d-hotline'> Express </th> <th class='border-eee p5 bgColor'> $150 per overseas shipment </th> <th class='border-eee p5 bgColor'> $150 per overseas shipment </th> </tr> </table> </div>",
        css: '--min-width: 600px;',
      },
      accessToken:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzk1MDg3MDcsInVzZXJfbmFtZSI6IjEtbXVtYmFpLXRhbGticml0ZSIsImF1dGhvcml0aWVzIjpbIkFkbWluIl0sImp0aSI6IjNiMmQ2OTM2LTU3MWUtNGU0Yi1hMWM5LWZhZTUwNzdmYWM4ZCIsImNsaWVudF9pZCI6ImRldmdsYW4tY2xpZW50Iiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXX0.cJ8Ij1QJUcCtOLZVKUg2jpeQwS3FCvUsxf5ThDIUiEY',
      latticeToken:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NzkyNzQzMjYsInVzZXJfbmFtZSI6IjEtbXVtYmFpLWtldmFsIiwiYXV0aG9yaXRpZXMiOlsiQWRtaW4iXSwianRpIjoiM2MxODcyYjktNzdkOS00N2I5LWE5NDgtOWQyN2M0MmY3OGJkIiwiY2xpZW50X2lkIjoiZGV2Z2xhbi1jbGllbnQiLCJzY29wZSI6WyJyZWFkIiwid3JpdGUiLCJ0cnVzdCJdfQ.u9JkANvrEf3MPApU1WYrYllqsRgkewytObJhCsxed38',
      fixSearchFilters: [
        {
          name: 'transType',
          values: ['SS'],
        },
        {
          name: 'department',
          values: ['Sales', 'KAM Sales'],
        },
      ],
      storeType: 'direct',
      loggedIn: '/diamond-search',
      loggedOut: '/login-with-sign-up',
      algoliaAppId: 'SGTTZIO938',
      algoliaSearchOnlyKey: 'c428d99b1b938d5bb665765a24887456',
      dealerClubMode: false,
      hosts: [
        {
          host: 'search.dev-api.lattice.mobioffice.io',
          auth: 'admin:admin',
          protocol: 'https',
          port: 443,
        },
      ],
      RESULTS_PER_PAGE: 10,
      INDEX: 'kglattice',
      themes:
        ' --ion-color-primary: #00A5C8; --ion-color-primary-rgb: 123,187,189; --ion-color-primary-contrast: #ffffff; --ion-color-primary-contrast-rgb: 0,0,0; --ion-color-primary-shade: #6ca5a6; --ion-color-primary-tint: #88c2c4; --ion-color-secondary: #ACACAC; --ion-color-secondary-rgb: 50,219,100; --ion-color-secondary-contrast: #000000; --ion-color-secondary-contrast-rgb: 0,0,0; --ion-color-secondary-shade: #2cc158; --ion-color-secondary-tint: #47df74; --ion-color-tertiary: #B4436C; --ion-color-tertiary-rgb: 180,67,108; --ion-color-tertiary-contrast: #ffffff; --ion-color-tertiary-contrast-rgb: 255,255,255; --ion-color-tertiary-shade: #9e3b5f; --ion-color-tertiary-tint: #bc567b; --ion-color-success: #2dd36f; --ion-color-success-rgb: 45,211,111; --ion-color-success-contrast: #ffffff; --ion-color-success-contrast-rgb: 255,255,255; --ion-color-success-shade: #28ba62; --ion-color-success-tint: #42d77d; --ion-color-warning: #ffc409; --ion-color-warning-rgb: 255,196,9; --ion-color-warning-contrast: #000000; --ion-color-warning-contrast-rgb: 0,0,0; --ion-color-warning-shade: #e0ac08; --ion-color-warning-tint: #ffca22; --ion-color-danger: #f53d3d; --ion-color-danger-rgb: 245,61,61; --ion-color-danger-contrast: #ffffff; --ion-color-danger-contrast-rgb: 255,255,255; --ion-color-danger-shade: #d83636; --ion-color-danger-tint: #f65050; --ion-color-dark: #424242; --ion-color-dark-rgb: 66,66,66; --ion-color-dark-contrast: #ffffff; --ion-color-dark-contrast-rgb: 255,255,255; --ion-color-dark-shade: #3a3a3a; --ion-color-dark-tint: #555555; --ion-color-medium: #989aa2; --ion-color-medium-rgb: 152,154,162; --ion-color-medium-contrast: #000000; --ion-color-medium-contrast-rgb: 0,0,0; --ion-color-medium-shade: #86888f; --ion-color-medium-tint: #a2a4ab; --ion-color-light: #F8F8F8; --ion-color-light-rgb: 248,248,248; --ion-color-light-contrast: #000000; --ion-color-light-contrast-rgb: 0,0,0; --ion-color-light-shade: #dadada; --ion-color-light-tint: #f9f9f9; --ion-font-family: Roboto Regular; --ion-color-background-hover: #222428;',
      lightLattice:
        ' --ion-color-primary: #00A5C8; --ion-color-primary-rgb: 123,187,189; --ion-color-primary-contrast: #ffffff; --ion-color-primary-contrast-rgb: 0,0,0; --ion-color-primary-shade: #6ca5a6; --ion-color-primary-tint: #88c2c4; --ion-color-secondary: #ACACAC; --ion-color-secondary-rgb: 50,219,100; --ion-color-secondary-contrast: #000000; --ion-color-secondary-contrast-rgb: 0,0,0; --ion-color-secondary-shade: #2cc158; --ion-color-secondary-tint: #47df74; --ion-color-tertiary: #B4436C; --ion-color-tertiary-rgb: 180,67,108; --ion-color-tertiary-contrast: #ffffff; --ion-color-tertiary-contrast-rgb: 255,255,255; --ion-color-tertiary-shade: #9e3b5f; --ion-color-tertiary-tint: #bc567b; --ion-color-success: #2dd36f; --ion-color-success-rgb: 45,211,111; --ion-color-success-contrast: #ffffff; --ion-color-success-contrast-rgb: 255,255,255; --ion-color-success-shade: #28ba62; --ion-color-success-tint: #42d77d; --ion-color-warning: #ffc409; --ion-color-warning-rgb: 255,196,9; --ion-color-warning-contrast: #000000; --ion-color-warning-contrast-rgb: 0,0,0; --ion-color-warning-shade: #e0ac08; --ion-color-warning-tint: #ffca22; --ion-color-danger: #f53d3d; --ion-color-danger-rgb: 245,61,61; --ion-color-danger-contrast: #ffffff; --ion-color-danger-contrast-rgb: 255,255,255; --ion-color-danger-shade: #d83636; --ion-color-danger-tint: #f65050; --ion-color-dark: #424242; --ion-color-dark-rgb: 66,66,66; --ion-color-dark-contrast: #ffffff; --ion-color-dark-contrast-rgb: 255,255,255; --ion-color-dark-shade: #3a3a3a; --ion-color-dark-tint: #555555; --ion-color-medium: #989aa2; --ion-color-medium-rgb: 152,154,162; --ion-color-medium-contrast: #000000; --ion-color-medium-contrast-rgb: 0,0,0; --ion-color-medium-shade: #86888f; --ion-color-medium-tint: #a2a4ab; --ion-color-light: #F8F8F8; --ion-color-light-rgb: 248,248,248; --ion-color-light-contrast: #000000; --ion-color-light-contrast-rgb: 0,0,0; --ion-color-light-shade: #dadada; --ion-color-light-tint: #f9f9f9; --ion-font-family: Roboto Regular; --ion-color-background-hover: #222428; --ion-color-heading : #000; --ion-color-background-color: #fff; --ion-color-inner-box-border: #fff;--ion-color-selections-border-color : #000;  --ion-color-inner-heading: #000; --ion-color-round-input : #555555; --ion-color-text-color: #000;  --ion-color-placeholder-color : #000;  --ion-color-label-color: #00A5C8;--ion-color-background-button: #f2f2f2; --ion-color-header-label: #fff; --ion-color-dx-data-grid-header: #b0daec; --ion-color-dx-data-grid-header-fields: #1a5490; --ion-color-dx-data-grid-checkbox: #00A5C8;--ion-color-dx-data-grid-pagination-bg: #F4F4F4; --ion-color-dx-data-grid-pagination-color: #000;--ion-color-cart-total: #000;--ion-color-inverse:#00A5C8',
      darkLattice:
        ' --ion-color-primary: #000; --ion-color-primary-rgb: 123,187,189; --ion-color-primary-contrast: #ffffff; --ion-color-primary-contrast-rgb: 0,0,0; --ion-color-primary-shade: #6ca5a6; --ion-color-primary-tint: #88c2c4; --ion-color-secondary: #ACACAC; --ion-color-secondary-rgb: 50,219,100; --ion-color-secondary-contrast: #000000; --ion-color-secondary-contrast-rgb: 0,0,0; --ion-color-secondary-shade: #2cc158; --ion-color-secondary-tint: #47df74; --ion-color-tertiary: #B4436C; --ion-color-tertiary-rgb: 180,67,108; --ion-color-tertiary-contrast: #ffffff; --ion-color-tertiary-contrast-rgb: 255,255,255; --ion-color-tertiary-shade: #9e3b5f; --ion-color-tertiary-tint: #bc567b; --ion-color-success: #2dd36f; --ion-color-success-rgb: 45,211,111; --ion-color-success-contrast: #ffffff; --ion-color-success-contrast-rgb: 255,255,255; --ion-color-success-shade: #28ba62; --ion-color-success-tint: #42d77d; --ion-color-warning: #ffc409; --ion-color-warning-rgb: 255,196,9; --ion-color-warning-contrast: #000000; --ion-color-warning-contrast-rgb: 0,0,0; --ion-color-warning-shade: #e0ac08; --ion-color-warning-tint: #ffca22; --ion-color-danger: #f53d3d; --ion-color-danger-rgb: 245,61,61; --ion-color-danger-contrast: #ffffff; --ion-color-danger-contrast-rgb: 255,255,255; --ion-color-danger-shade: #d83636; --ion-color-danger-tint: #f65050; --ion-color-dark: #424242; --ion-color-dark-rgb: 66,66,66; --ion-color-dark-contrast: #ffffff; --ion-color-dark-contrast-rgb: 255,255,255; --ion-color-dark-shade: #3a3a3a; --ion-color-dark-tint: #555555; --ion-color-medium: #989aa2; --ion-color-medium-rgb: 152,154,162; --ion-color-medium-contrast: #000000; --ion-color-medium-contrast-rgb: 0,0,0; --ion-color-medium-shade: #86888f; --ion-color-medium-tint: #a2a4ab; --ion-color-light: #F8F8F8; --ion-color-light-rgb: 248,248,248; --ion-color-light-contrast: #000000; --ion-color-light-contrast-rgb: 0,0,0; --ion-color-light-shade: #dadada; --ion-color-light-tint: #f9f9f9; --ion-font-family: Roboto Regular; --ion-color-background-hover: #222428;  --ion-color-heading : #000; --ion-color-background-color: #fff; --ion-color-inner-box-border: transparent; --ion-color-selections-border-color : #F18676; --ion-color-inner-heading: #000 ; --ion-color-round-input : #fff; --ion-color-text-color: #fff; --ion-color-placeholder-color : #555555; --ion-color-label-color: #F18676; --ion-color-background-button: #f2f2f2; --ion-color-header-label : #F18676; --ion-color-dx-data-grid-header: #fff; --ion-color-dx-data-grid-header-fields: #000; --ion-color-dx-data-grid-checkbox: #F18676; --ion-color-dx-data-grid-pagination-bg: #F18676; --ion-color-dx-data-grid-pagination-color: #fff; --ion-color-cart-total:#F18676; --ion-color-inverse:#F18676',
      baseURL: 'https://kgdiamonds.dealerclub.in/',
      isSearchHidden: false,
      hideFavourites: true,
      showContactUs: true,
      hideLogoOnSignup: true,
      headerToolbarClass: 'coloredHeader',
      headerIconColor: '#FFFFFF',
      hideLoginIcon: true,
      hideFooter: true,
      headerLinkRight: true,
      showSearch: true,
      showCartInSearchColumns: true,
      showMobileLogo: true,
      showCartAddedPopup: true,
      showFullMenu: true,
      hideInSmallScreen: true,
      hideMyNotifications: true,
      hideMyOrders: true,
      hideSavedCart: true,
      hideSavedSearches: true,
    },
    isSFEnabled: 0,
    pauseOrders: 0,
    pauseOrderMessage: '',
    id: 37,
    created_by: null,
    updated_by: null,
    created_date: null,
    updated_date: '2023-03-22T02:11:47.000Z',
  },
  viewActions: {
    viewProduct: 1,
    viewCollection: 2,
    addToCart: 3,
    removeFromCart: 4,
    buyProduct: 5,
    login: 6,
    cartReview: 7,
    reviewOrderSummary: 8,
    addressSelection: 9,
    quickBuyWithOTPInitiated: 10,
    quickBuyWithOTPVerified: 11,
    search: 12,
    quickBuyInitiated: 13,
    quickBuyFormError: 14,
    placeOrderClicked: 15,
    haveAQuestion: 16,
  },
  paymentDetails: [
    {
      name: 'Advance Payment',
      image: null,
      discount: null,
      flat: null,
      isOnline: false,
      id: 36,
      refCompanyId: 37,
      created_by: null,
      updated_by: null,
      created_date: null,
      updated_date: null,
    },
  ],
  themes:
    ' --ion-color-primary: #00A5C8; --ion-color-primary-rgb: 123,187,189; --ion-color-primary-contrast: #ffffff; --ion-color-primary-contrast-rgb: 0,0,0; --ion-color-primary-shade: #6ca5a6; --ion-color-primary-tint: #88c2c4; --ion-color-secondary: #ACACAC; --ion-color-secondary-rgb: 50,219,100; --ion-color-secondary-contrast: #000000; --ion-color-secondary-contrast-rgb: 0,0,0; --ion-color-secondary-shade: #2cc158; --ion-color-secondary-tint: #47df74; --ion-color-tertiary: #B4436C; --ion-color-tertiary-rgb: 180,67,108; --ion-color-tertiary-contrast: #ffffff; --ion-color-tertiary-contrast-rgb: 255,255,255; --ion-color-tertiary-shade: #9e3b5f; --ion-color-tertiary-tint: #bc567b; --ion-color-success: #2dd36f; --ion-color-success-rgb: 45,211,111; --ion-color-success-contrast: #ffffff; --ion-color-success-contrast-rgb: 255,255,255; --ion-color-success-shade: #28ba62; --ion-color-success-tint: #42d77d; --ion-color-warning: #ffc409; --ion-color-warning-rgb: 255,196,9; --ion-color-warning-contrast: #000000; --ion-color-warning-contrast-rgb: 0,0,0; --ion-color-warning-shade: #e0ac08; --ion-color-warning-tint: #ffca22; --ion-color-danger: #f53d3d; --ion-color-danger-rgb: 245,61,61; --ion-color-danger-contrast: #ffffff; --ion-color-danger-contrast-rgb: 255,255,255; --ion-color-danger-shade: #d83636; --ion-color-danger-tint: #f65050; --ion-color-dark: #424242; --ion-color-dark-rgb: 66,66,66; --ion-color-dark-contrast: #ffffff; --ion-color-dark-contrast-rgb: 255,255,255; --ion-color-dark-shade: #3a3a3a; --ion-color-dark-tint: #555555; --ion-color-medium: #989aa2; --ion-color-medium-rgb: 152,154,162; --ion-color-medium-contrast: #000000; --ion-color-medium-contrast-rgb: 0,0,0; --ion-color-medium-shade: #86888f; --ion-color-medium-tint: #a2a4ab; --ion-color-light: #F8F8F8; --ion-color-light-rgb: 248,248,248; --ion-color-light-contrast: #000000; --ion-color-light-contrast-rgb: 0,0,0; --ion-color-light-shade: #dadada; --ion-color-light-tint: #f9f9f9; --ion-font-family: Roboto Regular; --ion-color-background-hover: #222428;',
  devExtream: true,
  collectionOrderOptions: [
    {
      id: 3,
      name: 'Best Selling',
      field: 'popularityScore',
      ascDesc: 'DESC',
    },
    {
      id: 4,
      name: 'Newest First',
      field: 'id',
      ascDesc: 'DESC',
    },
    {
      id: 5,
      name: 'Price - high to low',
      field: 'maxPrice',
      ascDesc: 'DESC',
    },
    {
      id: 6,
      name: 'Price - low to high',
      field: 'minPrice',
      ascDesc: 'ASC',
    },
  ],
  collectionOrderOptionsTB: [
    {
      id: 1,
      name: 'Product Order',
      field: 'id',
      ascDesc: 'DESC',
    },
    {
      id: 2,
      name: 'Random',
      field: 'id',
      ascDesc: 'DESC',
    },
    {
      id: 3,
      name: 'Best Selling',
      field: 'popularityScore',
      ascDesc: 'DESC',
    },
    {
      id: 4,
      name: 'Newest First',
      field: 'id',
      ascDesc: 'DESC',
    },
    {
      id: 5,
      name: 'Price - high to low',
      field: 'maxPrice',
      ascDesc: 'DESC',
    },
    {
      id: 6,
      name: 'Price - low to high',
      field: 'minPrice',
      ascDesc: 'ASC',
    },
    {
      id: 7,
      name: 'Random Replacing',
      field: 'id',
      ascDesc: 'DESC',
    },
  ],
};
